import { useState } from 'react';
import { useAllPartnersIntroduction } from '../../hooks/partners-introduction';
import { PartnersModal } from '../modal/PartnersModal';

export const FifthSection = () => {
  const { data: partners } = useAllPartnersIntroduction();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [imgIndex, setImgIndex] = useState<number>(0);

  // 상세 모달 이미지는 장당 1~2MB다. 화면을 열 때 전부 받지 않고, 카드에 손/포커스가 닿을 때 그 한 장만 미리 받는다.
  const preloadModalImage = (modalImage?: string) => {
    if (!modalImage) return;
    const img = new Image();
    img.src = modalImage;
  };

  return (
    <div className="mx-auto w-full max-w-screen-xl space-y-5 px-5 md:space-y-10">
      <PartnersModal
        partners={partners ?? []}
        imgIndex={imgIndex}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />

      <p className="text-[26px] font-semibold md:text-[36px]">OUR PARTNERS</p>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
        {(partners ?? []).map((partner, index) => (
          <div key={partner.id} className="relative w-full">
            <button
              onPointerEnter={() => preloadModalImage(partner.modalImage)}
              onFocus={() => preloadModalImage(partner.modalImage)}
              onTouchStart={() => preloadModalImage(partner.modalImage)}
              onClick={() => {
                setModalOpen(true);
                setImgIndex(index);
              }}
            >
              <img
                src={partner.cardImage}
                alt=""
                loading="lazy"
                className="aspect-[734/1052] w-full rounded-lg object-cover"
              />

              <p className="absolute right-3 top-3 text-right text-[12px] font-medium text-white">
                상세보기
              </p>
              <p className="absolute bottom-7 left-5 right-5 whitespace-pre-wrap text-left text-[12px] text-white">
                {partner.summary}
              </p>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default { FifthSection };
